import { DateTime } from 'luxon';

import daysSinceLastCutOff from './daysSinceLastCutOff';
import fromWeeklyScheduleToTimePairsByWeekday from './fromWeeklyScheduleToTimePairsByWeekday';
import { WeeklySchedule } from './types';
import { DAYS_OF_WEEK } from './values';

const fromWeeklyScheduleToTimePairsByDate = (
  cutOffHour: number,
  timezone: string,
  now: number,
  weeklySchedule: WeeklySchedule,
) => {
  const timePairsByWeekday = fromWeeklyScheduleToTimePairsByWeekday(weeklySchedule);
  return daysSinceLastCutOff(7, cutOffHour, timezone, now).map(dateString => {
    const date = DateTime.fromISO(dateString, { zone: timezone });
    const weekday = DAYS_OF_WEEK[date.weekday - 1];
    return {
      date: dateString,
      timePairs: timePairsByWeekday[weekday],
    };
  });
};

export default fromWeeklyScheduleToTimePairsByDate;
